// link focus
// fix for problem described here https://axesslab.com/skip-links/
// taken from https://github.com/selfthinker/dokuwiki_template_writr/blob/master/js/skip-link-focus-fix.js
import ScrollToHelper from './ScrollToHelper';

class LinkFocusHelper {
    static focusOnElement($element) {
        if (!$element.length) {
            return;
        }
        if (!$element.is(':focusable')) {
            // add tabindex to make focusable and remove again
            $element.attr('tabindex', -1).on('blur focusout', () => {
                $element.removeAttr('tabindex');
            });
        }
        const fixedHeaderHeight = document.querySelector('.page-header__content-container').offsetHeight;
        requestAnimationFrame(() => {
            ScrollToHelper.scrollTo($element[0], fixedHeaderHeight);
        });
        $element.focus();
    }

    static handleHashLink() {
        // if there is a '#' in the URL (someone linking directly to a page with an anchor)
        if (document.location.hash) {
            LinkFocusHelper.focusOnElement($(document.location.hash));
        }

        // if the hash has been changed (activation of an in-page link)
        $(window).bind('hashchange', () => {
            const hash = `#${window.location.hash.replace(/^#/, '')}`;
            LinkFocusHelper.focusOnElement($(hash));
        });
    }
}

export default LinkFocusHelper;
